import Cotizacion from './Cotizacion'

export default Cotizacion
